export default class BooksActions {
  // namespace actions books fetch
  static BOOKS_FETCH_REQUEST = 'BOOKS_FETCH_REQUEST'
  static BOOKS_FETCH_SUCCESS = 'BOOKS_FETCH_SUCCESS'
  static BOOKS_FETCH_ERROR = 'BOOKS_FETCH_ERROR'
  // namespace actions modal
  static BOOKS_MODAL_TOGGLE_VIEW = 'BOOKS_MODAL_TOGGLE_VIEW'
  // namespace actions search
  static BOOKS_MODAL_CHANGE_SEARCH_TERM = 'BOOKS_MODAL_CHANGE_SEARCH_TERM'
  // namespace actions pagination
  static BOOKS_MODAL_CHANGE_ACTIVE_PAGE = 'BOOKS_MODAL_CHANGE_ACTIVE_PAGE'
  static BOOKS_MODAL_CHANGE_PAGE_COUNT = 'BOOKS_MODAL_CHANGE_PAGE_COUNT'
  // namespace actions filter
  static BOOKS_MODAL_CHANGE_FILTER = 'BOOKS_MODAL_CHANGE_FILTER'
  static BOOKS_MODAL_RESET_FILTER = 'BOOKS_MODAL_RESET_FILTER'
  // actions books fetch
  static fetchBooksRequest () {
    return {
      type: BooksActions.BOOKS_FETCH_REQUEST
    }
  }
  static fetchBooksSuccess (payload) {
    return {
      type: BooksActions.BOOKS_FETCH_SUCCESS,
      payload
    }
  }
  static fetchBooksError (payload) {
    return {
      type: BooksActions.BOOKS_FETCH_ERROR,
      payload
    }
  }

  // actions modal
  static ModalToggleView () {
    return {
      type: BooksActions.BOOKS_MODAL_TOGGLE_VIEW
    }
  }
  // actions search
  static ModalChangeSearchTerm (payload) {
    return {
      type: BooksActions.BOOKS_MODAL_CHANGE_SEARCH_TERM,
      payload
    }
  }
  // actions pagination
  static ModalChangeActivePage (payload) {
    return {
      type: BooksActions.BOOKS_MODAL_CHANGE_ACTIVE_PAGE,
      payload
    }
  }
  static ModalChangePageCount (payload) {
    return {
      type: BooksActions.BOOKS_MODAL_CHANGE_PAGE_COUNT,
      payload
    }
  }
  // actions filter
  static ModalChangeFilter (payload) {
    return {
      type: BooksActions.BOOKS_MODAL_CHANGE_FILTER,
      payload
    }
  }
  static resetBookFilter () {
    return {
      type: BooksActions.BOOKS_MODAL_RESET_FILTER
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/books/actions.js